import { defineMessage, useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavMenuPage, LinkSection } from "./mobile-nav-menu-page";

export const MobileNavWhyBitbucket = ({
    productKey = "bitbucket"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useWhyBitbucketLinks(): Array<LinkSection> {
        return [
            {
                key: "features",
                name: intl.formatMessage(
                    defineMessage({
                        id: "globalnavv2.subnav.whybitbucket.links.features",
                        defaultMessage: "Features"
                    })
                ),
                links: [
                    {
                        key: "ci-cd",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.ci-cd",
                                defaultMessage: "CI/CD"
                            })
                        ),
                        href: useLocalizedHref(
                            "/software/bitbucket/features/pipelines"
                        )
                    },
                    {
                        key: "cloud-security",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.it-service-management",
                                defaultMessage: "Cloud Security"
                            })
                        ),
                        href: useLocalizedHref(
                            "/software/bitbucket/features/cloud-security"
                        )
                    },
                    {
                        key: "dev-sec-ops",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.dev-sec-ops",
                                defaultMessage: "DevSecOps"
                            })
                        ),
                        href: useLocalizedHref(
                            "/software/bitbucket/features/devsecops"
                        )
                    },
                    {
                        key: "code-review",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.code-review",
                                defaultMessage: "Code Review"
                            })
                        ),
                        href: useLocalizedHref(
                            "/software/bitbucket/features/code-review"
                        )
                    },
                    {
                        key: "jira-integrations",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.jira-integrations",
                                defaultMessage: "Jira Integrations"
                            })
                        ),
                        href: useLocalizedHref(
                            "/software/jira/bitbucket-integration"
                        )
                    }
                ]
            },
            {
                key: "Plans",
                name: intl.formatMessage(
                    defineMessage({
                        id: "globalnavv2.subnav.whybitbucket.links.plans",
                        defaultMessage: "Plans"
                    })
                ),
                links: [
                    {
                        key: "bitbucket-cloud-premium",
                        text: intl.formatMessage(
                            defineMessage({
                                id: "globalnavv2.subnav.whybitbucket.links.bitbucket-cloud-premium",
                                defaultMessage: "Bitbucket Cloud Premium"
                            })
                        ),
                        href: useLocalizedHref("/software/bitbucket/premium")
                    }
                ]
            }
        ];
    }

    const whyBitbucketLinks = useWhyBitbucketLinks();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.whybitbucket.title",
                defaultMessage: "Why Bitbucket"
            })}
            cards={[]}
            linksSections={whyBitbucketLinks}
            productKey={productKey}
        />
    );
};
